
export const EventCategory = {
    MainPlayer: "Video Hub Page - Main player",
    Sections: "Video Hub Page - Content Sections"
}

export const EventAction = {
    PlayedVideoInMainPlayer: "Played video from main player",
    PlayedVideoInSection: (sectionNumber) => getPlayedVideoInSectionAction(sectionNumber)
}

const getPlayedVideoInSectionAction = (sectionNumber) => {
    return `Played video from content section ${sectionNumber}`
}

const getDataLayer = () => {
    return window.dataLayer
}

export const trackEvent = (category, action, label) => {
    const dataLayer = getDataLayer()
    if (dataLayer) {
        dataLayer.push({
            event: "GTM event To GA",
            GA_event_category: category,
            GA_event_action: action,
            GA_event_label: label
        })
    }
}